// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"4bd9f095","872":"4bd9f095"}[chunkId] + ".chunk.css";
};